// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./logout.png");
var dir = previousRequest.replace("logout.png", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "logout.png",
	name: "logout",
	ext: ".png",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/logout.png
// module id = 1079
// module chunks = 4